import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../../lib/shared/validators";

export const validatorStockStatus = v.object({
  productId: v.id("products"),
  // Opcional por retrocompatibilidad. Stock se resuelve por (producto, bodega) cuando existe.
  warehouseId: v.optional(v.id("warehouses")),
  available: v.number(),
  damaged: v.number(),
  expired: v.number(),
  lost: v.number(),
  reserved: v.number(),
  inTransit: v.number(),
  quarantine: v.optional(v.number()),

  totalPhysical: v.number(),
  totalSaleable: v.number(),

  minStockLevel: v.optional(v.number()),
  maxStockLevel: v.optional(v.number()),
  reorderPoint: v.optional(v.number()),
  reorderQuantity: v.optional(v.number()),

  isLowStock: v.optional(v.boolean()),
  isOutOfStock: v.optional(v.boolean()),
  hasExpiredItems: v.optional(v.boolean()),
  hasDamagedItems: v.optional(v.boolean()),

  batches: v.optional(
    v.array(
      v.object({
        batchNumber: v.string(),
        quantity: v.number(),
        expirationDate: v.optional(v.number()),
        status: v.string(),
      }),
    ),
  ),

  lastMovementDate: v.optional(v.number()),
  lastCountDate: v.optional(v.number()),

  internalControl,
});

export const stock_status = defineTable(validatorStockStatus)
  .index("by_product", ["productId"])
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_branchId", ["internalControl.branchId"])
  .index("by_productId_and_branchId", ["productId", "internalControl.branchId"])
  .index("by_product_and_warehouse", ["productId", "warehouseId"])
  .index("by_warehouse", ["warehouseId"])
  .index("by_low_stock", ["isLowStock"])
  .index("by_out_of_stock", ["isOutOfStock"])
  .index("by_expired", ["hasExpiredItems"])
  .index("by_damaged", ["hasDamagedItems"])
  .index("by_company_and_branch", [
    "internalControl.companyId",
    "internalControl.branchId",
  ]);
